import SHBridge from "shfe-shbridge";
import { Os } from "./SL-es";
export function get(params) {
  //       url, 请求地址
  //       params, 请求参数（公参除外）
  //       needEncryptRequest,（加密解密开关，勿管）
  //       needDecryptResult,
  //       encryptRequestType,
  //       needAddRequestHeader
  return shbridge(params, "nativeRequest");
}
function shbridge(params, method) {
  var method1;
  if (Os.ios) {
    if (method.indexOf("ad") > -1) {
      method1 = method.slice(3);
    } else {
      method1 = method;
    }
  } else {
    method1 = method;
  }
  let a = SHBridge.has(method1);
  if (a.constructor !== Object) {
    a = JSON.parse(a);
  }
  if (a.data.have) {
    return new Promise((res, rej) => {
      SHBridge.call(
        method,
        {
          ...params
        },
        result => {
          res(result);
        },
        error => {
          rej(error);
        }
      );
    });
  } else {
    console.log("该协议不支持当前版本");
  }
}
export function shareWalkPicture(params) {
  //type, 分享类型 目前仅有0
  //content; 分享图片地址链接(转成base 64)
  return shbridge(params, "shareWalkPicture");
}
export function uploadActivityLog(params) {
  return new Promise((res, rej) => {
    SHBridge.call(
      "uploadActivityLog",
      {
        thisurl: "",
        materialid: params.materialid || "",
        actentryid: params.actentryid || "",
        actid: params.actid || "",
        type: params.type || "",
        acttype: params.acttype || ""
      },
      result => {
        res(result);
      },
      error => {
        rej(error);
      }
    );
  });
}
export function toast(params) {
  // msg 吐司内容
  return shbridge(params, "toast");
}
export function copy(params) {
  return shbridge(params, "copy");
  //        msg: params.msg, //复制成功文案
  //        text: params.text //需要复制到剪贴板的文案
}
export function open(params) {
  return shbridge(params, "openNewWebView");
  //        url, //跳转链接
  //        barColor, //头部色值
  //        back, //是否需要返回按钮 '0'不需要 1需要
  //        hideBar
}
export function video(params) {
  return shbridge(params, "ad.video");
  //       position //广告位
}
export function dialog(params) {
  return shbridge(params, "ad.dialog");
  //       type, //弹窗广告类型
  //       gold, //奖励金币值
  //       total, //总金额（元单位）
  //       total_coin, //总金额（金币单位）
  //       position //广告位
}
export function openDialog(params) {
  return shbridge(params, "openDialog");
  //        type //1新人福利弹窗 2签到提醒弹窗
}
export function goBindMobile() {
  return shbridge(null, "goBindMobile");
}
export function wxAuthorize() {
  return shbridge(null, "wxAuthorize");
}
export function changeToAppPage(params) {
  return shbridge(params, "changeToAppPage");
  //       type //1主页面 2看看 3赚赚  4我的 5身体数据 6动动 7达标赛 8V5客服弹窗 9跑跑 10 IOS跳转设置目标步数 11健康评测 12健康报告 13睡觉赚钱 14今日健康 15智能设备列表 16首页健康模块
  // 17 跳转社区 18跳转社区话题（redirectId 话题id） 19发表动态（topicID话题id, topicName话题名, imgPath本地图片路径, content文字内容）20 个人中心（userId="",userName="",headImage=""  用户accid、用户头像、用户昵称 ）
}
export function getPollingData() {
  return shbridge(null, "getPollingData");
}
export function setUserInfo(params) {
  return shbridge(params, "setUserInfo");
  //     type: 2,
  //     userinfos //同步数据
}
export function accountGoldInfo() {
  return shbridge(null, "accountGoldInfo");
}
export function getBodyData() {
  return shbridge(null, "getBodyData");
}
export function goToViewLogin() {
  return SHBridge.callSync("goToViewLogin");
}
export function goPushView() {
  return shbridge(null, "goPushView");
}
export function getBracelet() {
  return shbridge(null, "getBracelet");
}
export function goBack() {
  return shbridge(null, "goBack");
}
export function taskCompletion(params) {
  /**
   * 页面打点上报 -- 异步
   * @param params {type}
   *     type 任务类型 1=集卡任务
   */
  return shbridge(params, "taskCompletion");
}
export function toOpenApp(params) {
  return shbridge(params, "toOpenApp");
  //        url, //唤醒三方app链接
  //        awakenId, // 唤醒三方App id 用来上传日志
  //        type //type 1 百川sdk唤醒淘宝。  默认普通唤醒
}
export function openLiteApp(params) {
  return shbridge(params, "openLiteApp");
  //        path, //拉起小程序页面的可带参路径，不填默认拉起小程序首页
  //        originalId // 小程序原始id
}
export function getInfo() {
  return SHBridge.callSync("getInfo");
}

/**
 * 获取广告云控数据 -- 异步
 */
export function getAdvPollingData(params) {
  return shbridge(params, "getAdvPollingData");
}

/**
 * 获取状态栏高度 -- 同步
 * @return 状态栏高度。此值为客户端单位值，使用此值除以 window.devicePixelRatio 即 css px 值
 */
export function getBarHeight() {
  return SHBridge.callSync("getBarHeight").data.height;
}

/**
 * 领取成就后上报给客户端 -- 同步
 */
export function uploadGetAchievement() {
  return SHBridge.callSync("getAchievement");
}

/**
 * 客户端缓存池set -- 同步
 */
export function setCache(param) {
  return SHBridge.callSync("setCache", param);
}

/**
 * 客户端缓存池get -- 同步
 * @return 存储key值对应数据
 */
export function getCache(param) {
  let a = SHBridge.callSync("getCache", param);
  if (a.data.result !== "") {
    return JSON.parse(a.data.result);
  }
}

/**
 * 页面打点上报 -- 异步
 * @param params {id}
 *     id 页面id，请询问产品
 */
export function dotStatistics(params) {
  return shbridge(params, "dotStatistics");
}

/**
 * 打开健康报告 -- 异步
 * @param params {type,bo,hr,sp,dp,sc}
 *     type 打开类型 1-根据传入的健康值生成健康报告
 *     bo 血氧值
 *     hr 心率值
 *     sp 血压-收缩压（高值）
 *     dp 血压-舒张压（低值）
 *     sc 健康数据得分
 */
export function openHealthReport(params) {
  return shbridge(params, "openHealthReport");
}

/**
 * 保存图片到本地 -- 异步
 * @param params {content}
 *     content 图片base64
 * @return {Promise} { imgLocalPath }
 *     imgLocalPath 图片本地路径
 */
export function savePicture(params) {
  return shbridge(params, "savePicture");
}

export default {
  goBack, //返回 --异步
  getBracelet, //获取手环连接状态
  get, //发送接口请求方法 --异步
  shareWalkPicture, //调起微信分享 --异步
  uploadActivityLog, //日志上报 --异步
  toast, //吐司 --异步
  copy, //复制文案 --异步
  open, //APP内新开页 --异步
  video, //激励视频广告 --异步
  dialog, //弹窗广告 --异步
  openDialog, //打开客户端部分弹窗 --异步
  goBindMobile, //跳转绑定手机页面 --异步
  wxAuthorize, //获取微信授权信息数据 --异步
  changeToAppPage, //原生页面跳转 --异步
  getPollingData, //获取总云控数据 --异步
  setUserInfo, //同步用户信息给到客户端 --异步
  accountGoldInfo, //获取用户金额 --异步
  getBodyData, //获取身体健康数据 --异步
  goToViewLogin, //去登录 --同步
  goPushView, //去设置推送页 --异步
  toOpenApp, //唤醒三方APP --异步
  openLiteApp, //打开微信小程序 --异步
  getInfo, //获取用户基本信息 --同步
  getAdvPollingData, // 获取广告云控数据 -- 异步
  getBarHeight, // 获取状态栏高度 -- 同步
  uploadGetAchievement, // 领取成就后上报给客户端 -- 同步
  dotStatistics, // 页面打点上报 -- 异步
  openHealthReport, // 打开健康报告 -- 异步
  savePicture, // 保存图片到本地 -- 异步
  taskCompletion, //同步任务状态给客户端 -- 异步
  getCache, //缓存池获取 -- 同步
  setCache //缓存池设置 -- 同步
};
// 注册调用方法：
// networkChange 获取网络状态
// 'viewDidAppear'	页面展示

// 'viewDisAppear'	页面切走

// 'appDidAppear'	app前台

// 'appDisAppear'	app后台运行
//链接拼参：isfullscreen 安卓隐藏title isstatusbar安卓隐藏时间电池条  hidenavbarIOS隐藏title  forbidSlideIOS禁用左滑右滑
